{
  "alpha_dash": "Det här fältet kan bara innehålla alfanumeriska tecken såväl som snedstreck och understreck",
  "alpha_num": "Det här fältet kan bara innehålla alfanumeriska tecken",
  "alpha_spaces": "Det här fältet kan bara innehålla bokstäver och mellanslag",
  "alpha": "Det här fältet kan bara innehålla bokstäver",
  "between": "Det här fältet måste vara mellan {{min}} och {{max}}",
  "confirmed": "Det här fältet matchar inte {{target}}",
  "digits": "Det här fältet måste vara numeriskt och innehålla exakt {{length}} siffor",
  "dimensions": "Det här fältet måste vara {{width}} pixlar bred och {{height}} pixlar hög",
  "email": "Det här fältet måste vara en giltig e-postadress",
  "excluded": "Det här fältet måste vara ett godkänt alternativ",
  "ext": "Det här fältet måste vara en godkänd fil",
  "image": "Det här fältet måste vara en bildfil",
  "integer": "Det här fältet måste vara ett heltal",
  "length": "Det här fältet måste vara {{length}} långt",
  "max_value": "Det här fältets värde får inte vara större än {max}",
  "max": "Det här fältet får inte vara längre än {{length}} tecken",
  "mimes": "Det här fältet måste ha en filändelse",
  "min_value": "Det här fältets värde får inte vara mindre än {{min}}",
  "min": "Det här fältet måste minst vara {{length}} tecken",
  "numeric": "Det här fältet kan bara innehålla numeriska tecken",
  "one_of": "Det här fältet måste vara ett godkänt alternativ",
  "regex": "Det här fältet har en felaktig formatering",
  "required": "Det här fältet är obligatoriskt",
  "size": "Det här fältet måste vara mindre än {{size}}KB"
}
